export default {
  "api":{
    "url": window.location.protocol + "//" + window.location.host + "/server/api"
  },
  "socket": {
    "url": window.location.protocol + "//" + window.location.host,
    "options": "/sockets"
  }
};
